import { render, staticRenderFns } from "./msgGoodsAsk.vue?vue&type=template&id=554d8621&scoped=true&"
import script from "./msgGoodsAsk.vue?vue&type=script&lang=js&"
export * from "./msgGoodsAsk.vue?vue&type=script&lang=js&"
import style0 from "./msgGoodsAsk.vue?vue&type=style&index=0&id=554d8621&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554d8621",
  null
  
)

export default component.exports